qw-room-rates {
  display: flex;
  flex-direction: column;
}

.qw-room-rates--card {
  overflow: scroll;
}

.qw-room-rates--card .qw-room-rates__wrapper {
  display: flex;
}
